import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { OnboardingService } from '../services/onboarding.service';
import type { SaveStepDto } from '../services/onboarding.service';

export const onboardingKeys = {
  all: ['onboarding'] as const,
  progress: () => [...onboardingKeys.all, 'progress'] as const,
} as const;

export function useOnboardingProgress(enabled = true) {
  return useQuery({
    queryKey: onboardingKeys.progress(),
    queryFn: () => OnboardingService.getProgress(),
    enabled,
    staleTime: 2 * 60 * 1000,
  });
}

export function useSaveOnboardingStep() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: SaveStepDto) => OnboardingService.saveStep(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingKeys.progress() });
    },
  });
}

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => OnboardingService.complete(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingKeys.progress() });
    },
  });
}
